var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.42829C0 1.16593 1.00736 0.142578 2.25 0.142578H15.75C16.9926 0.142578 18 1.16593 18 2.42829V3.57115H0V2.42829Z",
    fill: "#FB8041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.85686V11.5711C0 12.8335 1.00736 13.8569 2.25 13.8569H15.75C16.9926 13.8569 18 12.8335 18 11.5711V5.85686H0ZM3.375 8.14258H4.5C5.12132 8.14258 5.625 8.65425 5.625 9.28544V10.4283C5.625 11.0595 5.12132 11.5711 4.5 11.5711H3.375C2.75368 11.5711 2.25 11.0595 2.25 10.4283V9.28544C2.25 8.65425 2.75368 8.14258 3.375 8.14258Z",
    fill: "#FB8041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.e2365e28e6ef14dd65903b993376f0b2.svg";
export { ForwardRef as ReactComponent };